import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";

import firebaseConfig from "../firebasecfg";

import { getMoodboardImageRef } from "./utils";

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const dbPath = "moodboards";

const db = firebase.firestore();

export const subscribeToMoodboardItems = (
  moodboardPath,
  callback,
  isAuthenticated = false
) => {
  let query = db.collection(dbPath).where("path", "==", moodboardPath);

  // For unauthenticated users, we need to also filter by public=true
  // because Firebase rules require this for list queries
  if (!isAuthenticated) {
    query = query.where("public", "==", true);
  }

  query
    .get()
    .then((res) => {
      if (res.docs.length) {
        let doc = res.docs[0];
        let moodboardData = doc.data();
        callback({ id: doc.id, createdBy: moodboardData.createdBy });
        let unsubscribe = doc.ref.collection("items").onSnapshot(
          (snap) => {
            let items = {};
            for (let i in snap.docs) {
              let doc = snap.docs[i];
              items[doc.id] = doc.data();
            }
            callback({ items });
          },
          (err) => {
            callback({
              error: "error getting moodboard items",
            });
          }
        );

        callback({ unsubscribe });
      } else {
        // For unauthenticated users, no result might mean it's private
        callback({
          error: isAuthenticated ? "invalid path" : "private or invalid",
        });
      }
    })
    .catch((err) => {
      callback({ error: "Error subscribing" });
    });
};

const deleteMoodboardItemImage = (moodboardId, itemId, callback) => {
  let imageRef = getMoodboardImageRef(moodboardId, itemId);
  imageRef
    .delete()
    .then(() => {
      callback({ success: true });
    })
    .catch((err) => {
      if (err.code === "storage/object-not-found") {
        callback({ success: true });
      } else {
        callback({ error: "Error deleting image from storage" });
      }
    });
};

const dbDeleteMoodboardItem = (moodboardId, itemId, callback) => {
  db.collection(dbPath)
    .doc(moodboardId)
    .collection("items")
    .doc(itemId)
    .delete()
    .then(() => {
      callback({ success: true });
    })
    .catch((err) => {
      callback({ error: "Error deleting moodboard item" });
    });
};

export const deleteMoodboardItem = (moodboardId, itemId, callback) => {
  deleteMoodboardItemImage(moodboardId, itemId, ({ error }) => {
    if (error) {
      callback({ error });
    } else {
      dbDeleteMoodboardItem(moodboardId, itemId, callback);
    }
  });
};

const uploadMoodboardImage = (moodboardId, itemId, dataUrl, callback) => {
  if (itemId) {
    if (dataUrl) {
      let imageRef = getMoodboardImageRef(moodboardId, itemId);
      let uploadTask = imageRef.putString(dataUrl, "data_url");

      uploadTask
        .then(({ ref }) => {
          ref
            .getDownloadURL()
            .then((url) => callback({ uploadState: "success", url }))
            .catch({
              uploadError: "error",
              error: "error getting image url",
            });
        })
        .catch((err) => {
          callback({
            uploadState: "error",
            error: "error uploading image",
          });
        });

      uploadTask.on(
        "state_changed",
        ({ state, bytesTransferred, totalBytes }) => {
          switch (state) {
            case firebase.storage.TaskState.RUNNING:
              let progress = bytesTransferred / totalBytes;
              callback({ uploadState: "progress", progress });
              break;
            case firebase.storage.TaskState.ERROR:
              callback({
                uploadState: "error",
                error: "Error during upload",
              });
              break;
            case firebase.storage.TaskState.CANCELED:
              callback({ uploadState: "cancelled" });
              break;
            default:
              break;
          }
        }
      );
    } else {
      callback({
        error: "ERROR: no dataUrl provided when uploading item image",
      });
    }
  } else {
    callback({ error: "ERROR: no item id when uploading item image" });
  }
};

const dbSetMoodboardItem = (moodboardId, itemId, item, callback) => {
  if (itemId) {
    delete item.progress;
    delete item.error;
    delete item.uploading;
    delete item.dataUrl;

    db.collection(dbPath)
      .doc(moodboardId)
      .collection("items")
      .doc(itemId)
      .set(item)
      .then(() => {
        if (callback) callback({ success: true });
      })
      .catch((err) => {
        if (callback)
          callback({
            error: "Error editing moodboard item in database",
          });
      });
  } else {
    if (callback)
      callback({ error: "Error updating moodboard item - no item id" });
  }
};

export const saveMoodboardItem = (moodboardId, itemId, item, callback) => {
  if (itemId) {
    if (item.dataUrl) {
      uploadMoodboardImage(
        moodboardId,
        itemId,
        item.dataUrl,
        ({ uploadState, error, progress, url }) => {
          switch (uploadState) {
            case "error":
              callback({ error });
              break;
            case "success":
              delete item.dataUrl;
              item.url = url;
              dbSetMoodboardItem(moodboardId, itemId, item, callback);
              break;
            case "cancelled":
              callback({ error: "cancelled" });
              break;
            case "progress":
              callback({ progress });
              break;
            default:
              break;
          }
        }
      );
    } else {
      dbSetMoodboardItem(moodboardId, itemId, item, callback);
    }
  } else {
    callback({ error: "Error updating moodboard item - no item id" });
  }
};
